module.exports = __webpack_public_path__ + "static/media/hidroeletrica_banner.c16d6d0f.png";